import { createEnvironmentRuntimeAtoms } from "@afar-research/client-runtime/state/environments";

import { connectionAtomRuntime } from "./runtime";

export const hostEnvironment = createEnvironmentRuntimeAtoms(connectionAtomRuntime);
